import { error as errorReducer } from './Error.reducer';
import {
    PAYMENT_METHODS_RECEIVE,
    PAYMENT_METHODS_ERROR,
    PAYMENT_METHODS_ADDED
} from '../Actions/PaymentMethods.action';

const defaultState = {
    errors: {},
    hasSuccessfullyAdded: false
};

export const paymentMethods = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PAYMENT_METHODS_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case PAYMENT_METHODS_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        case PAYMENT_METHODS_ADDED:   
            return {
                ...state,
                hasSuccessfullyAdded: payload
            };
        default:
            return state;
    }
};
